<template>
  <div>
    <div
      v-if="accommodaties"
      class="my-4 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 grid-flow-row gap-4"
    >
      <div
        v-for="acc in accommodaties"
        :key="acc.id"
        @click="openAccomm(acc.id)"
        class="bg-gray-200 hover:bg-opacity-25 font-opensans rounded-lg shadow-lg hover:shadow-xl cursor-pointer"
      >
        <div
          class="py-2 px-2 text-center font-bold uppercase tracking-wide bg-mi-blue-500 rounded-t-lg text-gray-100 truncate"
        >
          {{ acc.naam }}
        </div>
        <p class="font-opensans mt-4 mx-4 text-sm truncate capitalize">
          {{ acc.adres }}
        </p>
        <p class="font-opensans mx-4 text-sm truncate capitalize">
          {{ acc.plaats }} ({{ acc.gemeente }})
        </p>

        <p class="font-opensans m-4 text-sm text-gray-500 truncate">
          <span v-for="sport in acc.sporten" v-bind:key="sport"
            >{{ sport }}
          </span>
        </p>
      </div>
    </div>
    <div
      v-else
      class="flex m-0 sm:m-0 md:m-0 lg:mx-2 xl:mx-2 lg:mt-2 xl:mt-2 p-3"
    >
      <div class="m-auto">
        <img src="../../assets/logo.svg" class="w-64 pl-8 mt-32" />
      </div>
    </div>
  </div>
</template>

<script>
import { sortByAttr } from "../../common/utils.js";
export default {
  name: "CardView",
  computed: {
    accommodaties() {
      if (!this.$store.state.backend_data_loaded) return [];
      return sortByAttr(
        this.$store.state.backend_data.accommodaties["results"],
        "name"
      ).slice(0, 20);
    }
  },
  methods: {
    openAccomm: function(id) {
      this.$router.push({ name: "Accommodatie", params: { id: id } });
    }
  }
};
</script>

<style scoped>
li {
  list-style: none;
  display: block;
  border-width: 2px;
  border-style: solid;
  border-color: darkgray;
  margin: 1em;
  padding: 1em;
}

li a {
  text-decoration: none;
  color: inherit;
}

li:hover {
  background-color: lightgray;
}

li:hover a {
  text-decoration: underline;
}
</style>
